__turbopack_context__.v({
  "freeBox__jc6Y": "PlasmicNewsItemPlaceholder-module__vvUnoG__freeBox__jc6Y",
  "freeBox__k2THm": "PlasmicNewsItemPlaceholder-module__vvUnoG__freeBox__k2THm",
  "links": "PlasmicNewsItemPlaceholder-module__vvUnoG__links",
  "loadingPlaceholder__bwHYf": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__bwHYf",
  "loadingPlaceholder__dIJa": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__dIJa",
  "loadingPlaceholder__hDyoY": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__hDyoY",
  "loadingPlaceholder__rvjg": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__rvjg",
  "loadingPlaceholder__up6B": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__up6B",
  "loadingPlaceholder__wlTCn": "PlasmicNewsItemPlaceholder-module__vvUnoG__loadingPlaceholder__wlTCn",
  "newsExcerptsItem": "PlasmicNewsItemPlaceholder-module__vvUnoG__newsExcerptsItem",
  "top": "PlasmicNewsItemPlaceholder-module__vvUnoG__top",
});
